import { render, staticRenderFns } from "./ProfileThemeSelection.vue?vue&type=template&id=49a4f56c&scoped=true&"
import script from "./ProfileThemeSelection.vue?vue&type=script&lang=js&"
export * from "./ProfileThemeSelection.vue?vue&type=script&lang=js&"
import style0 from "./ProfileThemeSelection.vue?vue&type=style&index=0&id=49a4f56c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a4f56c",
  null
  
)

export default component.exports